import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "./Loading";

type IdVerificationToggleRouteProps = {
	isLoadingToggles: boolean;
	idVerificationEnabled: boolean;
	children: ReactNode;
};

export const IdVerificationToggleRoute = ({
	isLoadingToggles,
	idVerificationEnabled,
	children,
}: IdVerificationToggleRouteProps) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!isLoadingToggles && !idVerificationEnabled) {
			navigate("/");
		}
	}, [idVerificationEnabled, isLoadingToggles, navigate]);

	if (isLoadingToggles) {
		return <Loading />;
	}

	if (!idVerificationEnabled) {
		return null;
	}

	return <>{children}</>;
};
